// @ts-nocheck
"use strict";
/* #region hide menu icon on click */ var icons = document.querySelector(".top-bar__icons");
var menuIcon = document.querySelector(".top-bar__icon--burger-menu");
var closeIcon = document.querySelector(".top-bar__icon--close");
var logoTopBar = document.querySelector(".menu .top-bar__logo-img");
var menuLinks = document.querySelectorAll(".nav--aside .nav__item:nth-of-type(-n+3)");
menuIcon === null || menuIcon === void 0 ? void 0 : menuIcon.addEventListener("click", function() {
    icons.classList.toggle("top-bar__icons--show");
});
closeIcon === null || closeIcon === void 0 ? void 0 : closeIcon.addEventListener("click", function() {
    icons.classList.toggle("top-bar__icons--show");
});
logoTopBar === null || logoTopBar === void 0 ? void 0 : logoTopBar.addEventListener("click", function() {
    icons.classList.toggle("top-bar__icons--show");
});
menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.forEach(function(node) {
    node === null || node === void 0 ? void 0 : node.addEventListener("click", function() {
        icons.classList.toggle("top-bar__icons--show");
    });
}); /* #end hide menu icon on click */ 

//# sourceMappingURL=index.18bc2e44.js.map
